import MainSlider from "../../../components/OrMainSlider";

export default MainSlider;
